import { Component } from 'react';
import PropTypes from 'prop-types';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
import * as MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';

class Geocoder extends Component {
  coordinatesGeocoder = function (query) {
    // match anything which looks like a decimal degrees coordinate pair
    var matches = query.match(/^[ ]*(?:Lat: )?(-?\d+\.?\d*)[, ]+(?:Lng: )?(-?\d+\.?\d*)[ ]*$/i);
    if (!matches) {
      return null;
    }
    
    function coordinateFeature(lng, lat) {
      return {
        center: [lng, lat],
        geometry: {
          type: "Point",
          coordinates: [lng, lat]
        },
        place_name: 'Lat: ' + lat + ', Lng: ' + lng, // eslint-disable-line camelcase
        place_type: ['coordinate'], // eslint-disable-line camelcase
        properties: {},
        type: 'Feature'
      };
    }
    
    var coord1 = Number(matches[1]);
    var coord2 = Number(matches[2]);
    var geocodes = [];
    
    if (coord1 < -90 || coord1 > 90) {
      // must be lng, lat
      geocodes.push(coordinateFeature(coord1, coord2));
    }
    
    if (coord2 < -90 || coord2 > 90) {
      // must be lat, lng
      geocodes.push(coordinateFeature(coord2, coord1));
    }
    
    if (geocodes.length === 0) {
      // else could be either lng, lat or lat, lng
      // geocodes.push(coordinateFeature(coord1, coord2));
      geocodes.push(coordinateFeature(coord2, coord1));
    }
 
    return geocodes;
  };

  componentDidMount() {
    const { map } = this.context;
    const { accessToken } = this.props

    const center = map.getCenter().wrap();

    const geocoder = new MapboxGeocoder({
      accessToken,
      localGeocoder: this.coordinatesGeocoder,
      placeholder: 'latitude, longitude',
      flyTo: true,
      setProximity: map.getZoom() > 9 ? { longitude: center.lng, latitude: center.lat } : null
    })
    
    map.addControl(
      geocoder
    );

    map.addSource('geocoder-marker', {
      "type": "geojson",
      "data": {
        "type": "FeatureCollection",
        "features": []
      }
    })

    map.addLayer({
      "id": "point",
      "source": "geocoder-marker",
      "type": "circle",
      "paint": {
        "circle-radius": 10,
        "circle-color": "#007cbf"
      }
    });

    geocoder.on('result', function(event) {
      map.getSource('geocoder-marker').setData(event.result.geometry);
    });

  }

  render() {
    return null;
  }

  static contextTypes = {
    map: PropTypes.object.isRequired
  };
}

export default Geocoder;



// WEBPACK FOOTER //
// ./src/containers/Geocoder.js